var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "d-flex full-center button-navbar",
      class: {
        "button-navbar-size-default": !_vm.sm && _vm.full,
        "button-navbar-size-sm": _vm.sm && _vm.full,
        "button-navbar-size-hidden": !_vm.full,
        "nav-icon-selected": _vm.selected,
        "nav-icon-just-selected": _vm.justSelected
      },
      staticStyle: { position: "relative" },
      style: {
        // border: showEffect ? borderOpacity() : '',
      },
      on: {
        click: _vm.clickEvent,
        mouseover: function($event) {
          _vm.isHover = true
        },
        mouseleave: function($event) {
          _vm.isHover = false
        }
      }
    },
    [
      _c("div", {
        class: { "button-navbar-selected": _vm.showEffect },
        staticStyle: { width: "293px", height: "56px", position: "absolute" },
        style: {
          background: _vm.showEffect ? _vm.bgColor() : "",
          left: _vm.full ? "-30px" : "-80px"
        }
      }),
      _c(
        "div",
        {
          staticClass: "d-flex",
          class: {
            "px-5": !_vm.sm,
            "px-3": _vm.sm
          },
          staticStyle: {
            position: "absolute",
            width: "100%",
            height: "100%",
            "z-index": "5",
            "background-blend-mode": "lighten"
          },
          style: {
            background: _vm.showEffect ? "#ffffff08" : ""
          }
        },
        [
          _vm.icon && _vm.icon.length
            ? _c("icon-svg", {
                staticClass: "navbar-main-icon",
                class: {
                  "is-detailed": _vm.isDetailedIcon,
                  "is-animating": _vm.iconAnimating
                },
                attrs: {
                  name: _vm.icon,
                  color: _vm.textColorContrastNav(),
                  size: "16"
                }
              })
            : _vm._e(),
          _vm.full
            ? _c(
                "div",
                {
                  staticClass:
                    "d-flex align-items-center justify-content-between",
                  style: { width: _vm.full ? "100%" : "auto" }
                },
                [
                  _c(
                    "p",
                    {
                      staticClass: "m-0",
                      class: {
                        "pl-4": !_vm.sm
                      },
                      style: {
                        color: _vm.textColorContrastNav()
                      }
                    },
                    [_vm._v(" " + _vm._s(_vm.name) + " ")]
                  ),
                  _vm.isNew || _vm.noAccessIcon
                    ? _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _vm.noAccessIcon
                            ? _c("IconNoModuleAccess", {
                                attrs: {
                                  iconSize: "14",
                                  lockNavBarOnHover: "",
                                  module: _vm.name
                                }
                              })
                            : _vm._e(),
                          _vm.isNew
                            ? _c(
                                "v-chip",
                                _vm._b(
                                  {},
                                  "v-chip",
                                  _vm.getChipNewModuleProps(),
                                  false
                                ),
                                [_vm._v(" Novo ")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.hasList
                    ? _c(
                        "v-btn",
                        { attrs: { icon: "", "x-small": "" } },
                        [
                          _c("icon-svg", {
                            class: {
                              "transform-rotate-0":
                                !_vm.arrowUp && !_vm.selected,
                              "transform-rotate-180":
                                _vm.arrowUp && _vm.selected
                            },
                            attrs: {
                              name: "arrow-up-light",
                              color: _vm.textColorContrastNav(),
                              size: "12"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }